import React, { Component } from 'react';
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { cloneDeep } from 'lodash';

class BranchToSectionMultiDDTillSecReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardIds: null,
            classIds: null,
            groupId: null,
            branchIds: null,
            sectionIds: null,
            boards: [],
            classes: [],
            sections: [],
            curriculumInfo: {}
        };
        this.service = new Service();
    }

    componentDidMount() {
        this.getData();
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.state.branchIds == null && this.props.boards && this.props.boards.length > 0 && this.props.branchData && this.props.branchData.length > 0 && this.props && this.props.dropdownsData !== undefined && this.props.dropdownsData !== null) {
            const { branchIds, boardIds, classIds, sectionIds } = this.props.dropdownsData;
            let branchdIds = branchIds;
            
            // Filter boards based on user role and selected branches
            let filteredBoards = this.getFilteredBoards(branchdIds);
            
            filteredBoards = cloneDeep(filteredBoards);
            
            if (filteredBoards.length > 0) {
                filteredBoards.forEach((board) => {
                    // Remove duplicate classes
                    board.classes = this.removeDuplicates(board.classes, 'classId');
                    
                    board?.classes?.forEach((classs) => {
                        classs.className = board?.boardName + ' -- ' + classs.className;
                        classs.sections.forEach((sec) => (sec.sectionName = classs.className + ' -- ' + sec.sectionName));
                    });
                });

                let filterClasses = filteredBoards
                    ?.filter((board) => boardIds?.includes(board.boardId))
                    ?.map((e) => e.classes)
                    .flat();

                let sections = filterClasses
                    .filter((e) => classIds?.includes(e.classId))
                    ?.map((e) => e.sections)
                    .flat();
                
                // Apply user role-based section filtering
                let filteredSections = this.getFilteredSections(sections);

                this.setState({
                    branchIds: branchdIds,
                    boards: filteredBoards,
                    boardIds: boardIds,
                    classes: filterClasses,
                    classIds: classIds,
                    sectionIds: sectionIds,
                    sections: filteredSections
                });
            }
        }
    }

    getData = () => {
        /* this.props.getBranchesLatest();
        this.props.getBoardsData(true); */
    };

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');
        
        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }
        
        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];
        
        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        const filtered = branchData.filter(branch =>
            userInfo.branchs.includes(branch.key)
        );
        
        return this.removeDuplicates(filtered, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoards = (selectedBranchIds) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = boards || [];

        // Filter by selected branches
        if (selectedBranchIds && selectedBranchIds.length > 0) {
            filteredBoards = filteredBoards.filter(board => 
                board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
            );
        }

        // If user is admin, return boards filtered only by selected branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(filteredBoards, 'boardId');
        }

        // For teachers, additionally filter by assigned boards
        if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }
        // For non-admin, non-teacher users, filter by assigned boards if available
        else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }

        // Remove duplicate boards by boardId
        return this.removeDuplicates(filteredBoards, 'boardId');
    }

    // Filter sections based on user role and assigned sections
    getFilteredSections = (sections) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections || [], 'sectionId');
        }

        // For teachers, filter by assigned sections
        if (this.isTeacher()) {
            // If teacher has no assigned sections, return empty array
            if (!userInfo?.sections || userInfo.sections.length === 0) {
                return [];
            }

            const filtered = sections.filter(section =>
                userInfo.sections.includes(section.sectionId)
            );
            return this.removeDuplicates(filtered, 'sectionId');
        }

        // For non-teacher users, return all sections
        return this.removeDuplicates(sections || [], 'sectionId');
    }

    onChangeBranch = (branchIds) => {
        this.setState({
            boards: [],
            classes: [],
            sections: []
        });

        // Filter boards based on user role and selected branches
        let filteredBoards = this.getFilteredBoards(branchIds);
        
        filteredBoards = cloneDeep(filteredBoards);

        filteredBoards.forEach((board) => {
            // Remove duplicate classes
            board.classes = this.removeDuplicates(board.classes, 'classId');
            
            board?.classes?.forEach((classs) => {
                classs.className = board?.boardName + ' -- ' + classs.className;
                classs.sections.forEach((sec) => (sec.sectionName = classs.className + ' -- ' + sec.sectionName));
            });
        });

        this.setState(
            {
                branchIds: branchIds,
                boards: filteredBoards,
                classes: [],
                boardIds: '',
                classIds: '',
                branches: [],
                sections: [],
                sectionIds: []
            },
           
        );
    };

    onChangeBoard = (boardIds) => {
        this.setState({
            classes: [],
            sections: []
        });

        let filteredClasses = [];

        this.state.boards.forEach((board) => {
            if (boardIds.includes(board.boardId)) {
                filteredClasses.push(...board.classes);
            }
        });

        this.setState(
            {
                classes: filteredClasses,
                boardIds,
                classIds: '',
                branches: [],
                sections: [],
                sectionIds: []
            },
          
        );
    };

    onChangeClass = (classIds) => {
        this.setState({
            sections: []
        });
        let filterClasses1 = this.state.classes?.filter((classs) => classIds?.includes(classs?.classId));
        let lsecs = [];
        filterClasses1?.map((fClass) => {
            let secc = fClass.sections?.filter((sec) => this.state.branchIds?.includes(sec?.branchId));
            lsecs = [...lsecs, ...secc];
        });
        
        // Apply user role-based section filtering
        lsecs = this.getFilteredSections(lsecs);
        
        this.setState(
            {
                classIds: classIds,
                sections: lsecs,
                sectionIds: []
            },
           
        );
    };

    onChangeSection = (sectionIds) => {
        this.setState(
            {
                sectionIds: sectionIds
            },
            () => this.setDropdownsData()
        );
    };

    setDropdownsData = () => {
        let { boardIds, classIds, branchIds, sectionIds } = this.state;
        let branchNames,
            sectionNames = [];
        if (sectionIds?.length) {
            branchNames = branchIds?.map((e) => this.props.branchData?.find((f) => e == f.key).name);
            sectionNames = sectionIds?.map((e) => this.state?.sections?.find((f) => e == f.sectionId)?.sectionName);
        }

        this.props.setValues({
            boardIds,
            classIds,
            branchIds,
            sectionIds,
            branchNames,
            sectionNames
        });
    };

    render() {
        // Get filtered branches for dropdown
        const filteredBranchData = this.getFilteredBranches();
        
        return (
            <div>
                <div>
                    <div className="grid">
                        <div className=" col-3">
                            <ClassetMultiSelect
                                required={true}
                                label={'Branch'}
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder={'Select Branch'}
                                options={filteredBranchData}
                                value={this.state.branchIds}
                                onChange={(e) => this.onChangeBranch(e.value)}
                                optionLabel="name"
                                optionValue="key"
                            />
                        </div>
                        <div className=" col-3">
                            <ClassetMultiSelect
                                required={true}
                                label={'Board'}
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder={'Select Board'}
                                options={this.state.boards}
                                value={this.state.boardIds}
                                onChange={(e) => this.onChangeBoard(e.value)}
                                optionLabel="boardName"
                                optionValue="boardId"
                            />
                        </div>
                        <div className=" col-3">
                            <ClassetMultiSelect
                                label={'Grade'}
                                required={true}
                                // icon={<GradesIcon />}
                                placeholder={'Select (Board - Grade)'}
                                options={this.state?.classes}
                                value={this.state.classIds}
                                onChange={(e) => this.onChangeClass(e.value)}
                                optionLabel="className"
                                optionValue="classId"
                            />
                        </div>
                        <div className=" col-3">
                            <ClassetMultiSelect
                                required={true}
                                label={'Section'}
                                // icon={<GradesIcon />}
                                placeholder={'Select (Board - Grade - Section)'}
                                options={this.state?.sections}
                                value={this.state.sectionIds}
                                onChange={(e) => this.onChangeSection(e.value)}
                                optionLabel="sectionName"
                                optionValue="sectionId"
                            />
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && (
                    <>
                        <LoadingComponent />
                    </>
                )}
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {}
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToSectionMultiDDTillSecReports);
